import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserAstronaut } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import Card from '../Card';
import aboutImagePng from '../../assets/images/station.png';
import aboutImageWebp from '../../assets/images/station.webp';
import './about.scss';

const About = () => {
    const { t } = useTranslation();
    return (
        <section className="about aboutme" id="about">
            <div className="container">
                <div className="row section-separator">
                    <div className="col-sm-12 col-md-6 aboutme-image-container">
                        <div className="about-preview" data-aos="fade-up">
                            <picture>
                                <source srcSet={aboutImageWebp} type="image/webp" />
                                <source srcSet={aboutImagePng} type="image/png" />
                                <img src={aboutImagePng} alt="" className="img-fluid" />
                            </picture>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 infos">
                        <div className="about-details">
                            <Card icon={<FontAwesomeIcon icon={faUserAstronaut} className="icon" />}>
                                <h4 className="title">{t('AboutMe.Title')}</h4>
                                <p className="description">{t('AboutMe.Infos')}</p>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
